import { render, staticRenderFns } from "./PremiumNoLogin.vue?vue&type=template&id=e070b174&"
import script from "./PremiumNoLogin.vue?vue&type=script&lang=js&"
export * from "./PremiumNoLogin.vue?vue&type=script&lang=js&"
import style0 from "./PremiumNoLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports